import React from "react";
import { Container, Typography, Grid, Card, CardContent, Box, TextField, Button } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import "./Contact.css"; // Ensure CSS is linked

const Contact = () => {
  return (
    <div className="contact-container">
      <Container maxWidth="md">
        <Typography variant="h3" className="contact-title" gutterBottom>
          Contact Us
        </Typography>
        <Typography variant="body1" className="contact-subtitle">
          We’d love to discuss your dream project. Get in touch with us today!
        </Typography>

        <Grid container spacing={4} className="contact-grid">
          {/* Address Card */}
          <Grid item xs={12} md={6}>
            <Card className="contact-card">
              <CardContent>
                <Box className="icon-container">
                  <LocationOnIcon className="contact-icon" />
                </Box>
                <Typography variant="h6" className="contact-card-title">
                  📍 Address
                </Typography>
                <Typography variant="body2" className="contact-card-text">
                  CaRE Constructions  
                  Plot 1, Dr. Abdul Kalam Road, Pudupakkam,  
                  Opposite to ISHA MIA VILLAS, Kelambakkam,  
                  Chennai-603103, Tamil Nadu, India.
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Phone & Email Card */}
          <Grid item xs={12} md={6}>
            <Card className="contact-card">
              <CardContent>
                <Box className="icon-container">
                  <PhoneIcon className="contact-icon" />
                </Box>
                <Typography variant="h6" className="contact-card-title">
                  📞 Phone
                </Typography>
                <Typography variant="body2" className="contact-card-text">
                  +91 90875 98811
                </Typography>
              </CardContent>
            </Card>
            <Card className="contact-card">
              <CardContent>
                <Box className="icon-container">
                  <EmailIcon className="contact-icon" />
                </Box>
                <Typography variant="h6" className="contact-card-title">
                  📧 Email
                </Typography>
                <Typography variant="body2" className="contact-card-text">
                  dhamu@carelab.in
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Contact Form */}
        <Card className="contact-form-card">
          <CardContent>
            <Typography variant="h5" className="contact-form-title">
              Send Us a Message
            </Typography>
            <form className="contact-form">
              <TextField label="Your Name" fullWidth className="contact-input" />
              <TextField label="Email" fullWidth className="contact-input" />
              <TextField label="Message" fullWidth multiline rows={4} className="contact-input" />
              <Button variant="contained" className="contact-button">
                Submit
              </Button>
            </form>
          </CardContent>
        </Card>
      </Container>
    </div>
  );
};

export default Contact;
